import React from 'react';
import { postOpHours } from '../../app-main/actions/calendar';
import { SubmissionError } from 'redux-form';
import { get, reduce, set, isEmpty } from 'lodash';
import { toggleModal } from '../../app-main/actions/modal';
import { push } from 'react-router-redux';
import { FormattedMessage } from 'react-intl';

const onSubmitOpHoursForm = (values = {}, dispatch, props) => {
  const { space, accessToken, isEdit } = props;
  const spaceId = get(space, '_id');
  const opHours = get(values, 'opHours');
  const longitude = get(space, 'longitude');
  const latitude = get(space, 'latitude');

  const timeOverlapError = <FormattedMessage id="hosting.on_submit_op_hours_form.time_overlap_error_message" defaultMessage="Please adjust your time slots so they do not overlap" />;
  const submissionFailedError = <FormattedMessage id="hosting.on_submit_op_hours_form.submission_failed_error_message" defaultMessage="Submission failed. Please refresh and try again." />;

  const flatOperatingHours = reduce(opHours, (result, value) => {
    const dowsArray = value.dows;

    return result.concat(dowsArray);
  }, []).filter((obj) => !isEmpty(obj));

  const payload = {
    latitude,
    longitude,
    operating_hours: flatOperatingHours
  };

  return dispatch(postOpHours(spaceId, accessToken, payload))
    .then(() => {
      if (isEdit) {
        return dispatch(toggleModal({ modalId: 'ContinueModal' }));
      }

      return dispatch(push(`/your-space/${spaceId}/cleaning-policy`));
    })
    .catch(({ error, error_type: errorType }) => {
      let opHours = {};

      if ('overlapping_hours' === errorType) {
        opHours = reduce(error, (item, value, key) => {
          const newItem = set(item, [key, 'dows', '_error'], timeOverlapError);

          return newItem;
        }, {});
      }

      throw new SubmissionError({
        ...('spec failed' === error && { _error: submissionFailedError }),
        opHours
      });
    });
};

export default onSubmitOpHoursForm;
